import React from "react";
import LeadForm from "../components/LeadForm";

const LeadAddPage = (props) => {
  // Read prefilled mobile from URL query string (?mobile=XXXXXXXXXX)
  const params = new URLSearchParams(props.location ? props.location.search : "");
  const prefillMobile = params.get("mobile") || "";

  return (
    <div>
      <h2 className="page-header">Add New Lead</h2>
      <LeadForm isEdit={false} history={props.history} prefillMobile={prefillMobile} />
    </div>
  );
};

export default LeadAddPage;
